module.exports = __webpack_public_path__ + "media/images/lp_v6_img08-d87c2cdf8c54f51ecfe39361f720c622.webp";